import { FC } from 'react'
import './styles.css'
import { ContentContainer } from '../ContentContainer/ContentContainer'

const Footer: FC = () => {
  return (
    <footer className="footer-component">
      <ContentContainer>
        <div className="footer-content">
          <div className="footer-general-info">
            <span>{'© BMW ' + new Date().getFullYear()}</span>
          </div>
        </div>
      </ContentContainer>
    </footer>
  )
}

export default Footer
